import client from "./client";

const textCard = (card = {}) => ({
  title: card.title || "",
  description: card.description || "",
});

const insightCard = (card = {}) => ({
  type: card.type || "",
  title1: card.title1 || "",
  title2: card.title2 || "",
  description: card.description || "",
  link: card.link || "",
});

export function prepareHomepage(form = {}) {
  const payload = {};
  const text = (key) => {
    if (form[key] !== undefined) payload[key] = form[key] ?? "";
  };
  const bool = (key) => {
    if (form[key] !== undefined) payload[key] = !!form[key];
  };

  [
    "heroTag",
    "heroTitle1",
    "heroTitle2",
    "heroDescription",
    "heroPrimaryCtaText",
    "heroPrimaryCtaLink",
    "heroSecondaryCtaText",
    "heroSecondaryCtaLink",
    "heroTrustText",
    "servicesTitle",
    "servicesSubtitle",
    "servicesFooterText",
    "servicesCtaText",
    "servicesCtaLink",
    "processTitle",
    "processSubTitle",
    "processStep1BtnText",
    "processStep1BtnLink",
    "insightsTitle",
    "insightsCtaText",
    "insightsCtaLink",
  ].forEach(text);

  ["heroSectionHide", "servicesHide", "processHide", "insightsHide"].forEach(
    bool
  );

  if (form.heroLogoCard !== undefined) {
    payload.heroLogoCard = {
      image: form.heroLogoCard?.image || "",
      text: form.heroLogoCard?.text || "",
    };
  }
  if (form.heroCard1 !== undefined) payload.heroCard1 = textCard(form.heroCard1);
  if (form.heroCard2 !== undefined) payload.heroCard2 = textCard(form.heroCard2);
  if (form.services !== undefined) {
    payload.services = (form.services || []).map(textCard);
  }
  if (form.processSteps !== undefined) {
    payload.processSteps = (form.processSteps || []).map((step, index) => ({
      step: Number(step.step) || index + 1,
      title: step.title || "",
      description: step.description || "",
    }));
  }
  if (form.insight1 !== undefined) payload.insight1 = insightCard(form.insight1);
  if (form.insight2 !== undefined) payload.insight2 = insightCard(form.insight2);
  if (form.insight3 !== undefined) payload.insight3 = insightCard(form.insight3);

  return payload;
}

export const getHomepage = () => client.post("/homepage/getPage");
export const addHomepage = (payload) =>
  client.post("/homepage/addhomepage", payload);
export const updateHomepage = (payload) =>
  client.post("/homepage/updatePage", payload);
export const deleteHomepage = () => client.post("/homepage/deletePage");
